import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import MuiButton from '@material-ui/core/Button';
var useStyles = makeStyles(function (_a) {
    var _b, _c;
    var palette = _a.palette, breakpoints = _a.breakpoints, borderRadius = _a.borderRadius, boxShadows = _a.boxShadows;
    return createStyles({
        root: (_b = {
                boxShadow: boxShadows.none,
                textTransform: 'none'
            },
            _b[breakpoints.up('xs')] = {
                height: '32px',
                lineHeight: '20px',
            },
            _b[breakpoints.up('md')] = {
                height: '40px',
                lineHeight: '28px',
            },
            _b),
        contained: {
            color: palette.other.contrastText,
            backgroundColor: palette.secondary.main,
            '&:hover': {
                backgroundColor: palette.secondary.dark,
                boxShadow: boxShadows.none,
            },
            '&:active': {
                backgroundColor: palette.secondary.activeContained,
                boxShadow: boxShadows.none,
            },
            '& path': {
                fill: palette.other.contrastText,
            },
        },
        containedRed: {
            color: palette.other.contrastText,
            backgroundColor: palette.error.main,
            '&:hover': {
                backgroundColor: palette.error.dark,
                boxShadow: boxShadows.none,
            },
            '&:active': {
                backgroundColor: palette.error.light,
                boxShadow: boxShadows.none,
            },
        },
        outlined: {
            color: palette.other.primary,
            backgroundColor: palette.other.contrastText,
            '&:hover': {
                backgroundColor: palette.actions.hover,
                boxShadow: boxShadows.none,
            },
            '&:active': {
                backgroundColor: palette.actions.outlinedStroke,
                boxShadow: boxShadows.none,
            },
            '& path': {
                fill: palette.other.primary,
            },
        },
        outlinedRed: {
            color: palette.error.dark,
            backgroundColor: palette.other.contrastText,
            borderColor: palette.error.dark,
            '&:hover': {
                backgroundColor: palette.error.lightBg,
                boxShadow: boxShadows.none,
            },
            '&:active': {
                backgroundColor: palette.error.lightBg,
                boxShadow: boxShadows.none,
            },
        },
        text: {
            color: palette.secondary.main,
            backgroundColor: palette.other.contrastText,
            '&:hover': {
                backgroundColor: palette.secondary.hover,
                boxShadow: boxShadows.none,
            },
            '&:active': {
                backgroundColor: palette.secondary.activeOutlined,
                boxShadow: boxShadows.none,
            },
            '& path': {
                fill: palette.secondary.main,
            },
        },
        icon: {
            minWidth: 'auto',
            padding: '0px',
            borderRadius: borderRadius.circle,
            color: palette.actions.outlinedStroke,
            backgroundColor: palette.other.contrastText,
            '& path': {
                fill: palette.other.disabled,
            },
            '&:hover': {
                color: palette.other.contrastText,
                backgroundColor: palette.secondary.dark,
                borderColor: palette.secondary.dark,
                boxShadow: boxShadows.none,
                '& path': {
                    fill: palette.other.contrastText,
                },
            },
            '&:active': {
                backgroundColor: palette.secondary.activeContained,
                borderColor: palette.secondary.activeContained,
                boxShadow: boxShadows.none,
            },
        },
        iconOutlined: (_c = {},
            _c[breakpoints.up('xs')] = {
                width: '40px',
                height: '40px',
            },
            _c[breakpoints.up('md')] = {
                width: '48px',
                height: '48px',
            },
            _c),
        iconDisabled: {
            color: palette.actions.outlinedStroke + " !important",
            backgroundColor: palette.actions.disabledBackground,
            borderColor: palette.actions.disabledBackground + " !important",
        },
    });
});
export var Button = function (_a) {
    var variant = _a.variant, red = _a.red, label = _a.label, _b = _a.fullWidth, fullWidth = _b === void 0 ? true : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, startIcon = _a.startIcon, icon = _a.icon, onClick = _a.onClick;
    var classes = useStyles();
    if (variant === 'icon') {
        return (React.createElement(MuiButton, { classes: {
                root: classes.icon,
                outlined: classes.iconOutlined,
                disabled: classes.iconDisabled,
            }, variant: "outlined", disabled: disabled, onClick: onClick }, icon));
    }
    return (React.createElement(MuiButton, { classes: {
            root: classes.root,
            contained: red ? classes.containedRed : classes.contained,
            outlined: red ? classes.outlinedRed : classes.outlined,
            text: classes.text,
        }, variant: variant, fullWidth: fullWidth, disabled: disabled, startIcon: startIcon, onClick: onClick }, label));
};
